// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { s_feather, s_card_red, s_card_blue, s_card_yellow, s_card_bomb, s_balloon_red, s_balloon_blue, s_balloon_yellow, s_cage, tnt_box, s_static_ground, WOOD_TRIANGLE_4X4_D1, WOOD_TRIANGLE_4X4_D1_2, WOOD_TRIANGLE_4X4_HOLLOW_D1_2, WOOD_CIRCLE_2X2_D1, WOOD_CIRCLE_4X4_D1, WOOD_BLOCK_1X1_D1, WOOD_BLOCK_2X1_D1, WOOD_BLOCK_2X2_D1, WOOD_BLOCK_4X1_D1, WOOD_BLOCK_8X1_D1, WOOD_BLOCK_10X1_D1, WOOD_BLOCK_4X2_D1, WOOD_BLOCK_8X2_D1, WOOD_BLOCK_10X2_D1, WOOD_BLOCK_4X4_D1, WOOD_BLOCK_4X4_HOLLOW_D1, ICE_TRIANGLE_4X4_D1, ICE_TRIANGLE_4X4_D1_2, ICE_TRIANGLE_4X4_HOLLOW_D1_2, ICE_CIRCLE_2X2_D1, ICE_CIRCLE_4X4_D1, ICE_BLOCK_1X1_D1, ICE_BLOCK_2X1_D1, ICE_BLOCK_2X2_D1, ICE_BLOCK_4X1_D1, ICE_BLOCK_8X1_D1, ICE_BLOCK_10X1_D1, ICE_BLOCK_4X2_D1, ICE_BLOCK_8X2_D1, ICE_BLOCK_10X2_D1, ICE_BLOCK_4X4_D1, ICE_BLOCK_4X4_HOLLOW_D1, STONE_TRIANGLE_4X4_D1, STONE_TRIANGLE_4X4_D1_2, STONE_TRIANGLE_4X4_HOLLOW_D1_2, STONE_CIRCLE_2X2_D1, STONE_CIRCLE_4X4_D1, STONE_BLOCK_1X1_D1, STONE_BLOCK_2X1_D1, STONE_BLOCK_2X2_D1, STONE_BLOCK_4X1_D1, STONE_BLOCK_8X1_D1, STONE_BLOCK_10X1_D1, STONE_BLOCK_4X2_D1, STONE_BLOCK_8X2_D1, STONE_BLOCK_10X2_D1, STONE_BLOCK_4X4_D1, STONE_BLOCK_4X4_HOLLOW_D1, s_card_big, s_card_mathilda, s_s_matilda_egg } from "../code/AssetDefinitions/ImageDefinitions";
import { p_feather_red, p_feather_blue, p_feather_yellow, p_feather_black } from "../code/AssetDefinitions/JsonDefinitions";
import { s_redBird, s_smokePuff, s_tnt, s_blueBird, s_yellowBird, s_bombBird, s_pig_animation, s_birdTerence_animation, s_birdMatilda_animation } from "../code/AssetDefinitions/SpineDefinitions";
import { explosionTypeTNT, explosionTypeEgg } from "./Explosion";
import { DamageFactors, PhysicsObjectType } from "./PhysicsSettings";
import { PigSettings } from "./Settings";
import { SoundManager } from "./SoundManager";
// NOTE: Please add new blocks to the bottom of this object, adding them halfway will cause issues with the replays
export var PhysicsObjectDefinition = {
    "RedBird": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 1.7,
        height: 1.7,
        materialName: "RedBird",
        spine: s_redBird,
        animation: {
            scale: 0.5,
            idle: "red_idle",
            animation: "red_fly",
            loop: false
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_red"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_red
        },
        sounds: SoundManager.BirdCollection.RED,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.RedBirdDamageFactors,
        cardImage: s_card_red,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "BlueBird": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 1.5,
        height: 1.5,
        materialName: "BlueBird",
        spine: s_blueBird,
        animation: {
            scale: 0.5,
            idle: "blue_idle",
            animation: "blue_fly",
            loop: false,
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_blue"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_blue
        },
        sounds: SoundManager.BirdCollection.BLUE,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.BlueBirdDamageFactors,
        cardImage: s_card_blue,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "YellowBird": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 1.6,
        height: 1.6,
        materialName: "YellowBird",
        spine: s_yellowBird,
        animation: {
            scale: 0.5,
            idle: "chuck_idle",
            animation: "chuck_fly",
            loop: false
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_chuck"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_yellow
        },
        sounds: SoundManager.BirdCollection.YELLOW,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.YellowBirdDamageFactors,
        cardImage: s_card_yellow,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "BlackBird": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 2,
        height: 2,
        materialName: "BlackBird",
        spine: s_bombBird,
        animation: {
            scale: 0.5,
            idle: "bomb_idle",
            animation: "bomb_fly",
            loop: false
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_bomb"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_black
        },
        sounds: SoundManager.BirdCollection.BLACK,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.BlackBirdDamageFactors,
        cardImage: s_card_bomb,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "MISC_BALLOON_RED": {
        type: PhysicsObjectType.circle,
        image: s_balloon_red,
        width: 3,
        height: 3,
        materialName: "Balloon"
    },
    "MISC_BALLOON_BLUE": {
        type: PhysicsObjectType.circle,
        image: s_balloon_blue,
        width: 3,
        height: 3,
        materialName: "Balloon"
    },
    "MISC_BALLOON_YELLOW": {
        type: PhysicsObjectType.circle,
        image: s_balloon_yellow,
        width: 3,
        height: 3,
        materialName: "Balloon"
    },
    "NEW17_NHL_2015_METAL_GRID_A": {
        type: PhysicsObjectType.box,
        image: s_cage,
        width: 4,
        height: 4,
        materialName: "Metal",
    },
    "MISC_EXPLOSIVE_TNT": {
        type: PhysicsObjectType.box,
        image: tnt_box,
        width: 2.8,
        height: 2.8,
        materialName: "Extras",
        deathExplosion: explosionTypeTNT
    },
    "PIG_BASIC_MEDIUM_ALLY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 4,
        height: 4,
        materialName: "Pig",
        spine: s_pig_animation,
        animation: {
            scale: 0.4,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "PIG_BASIC_MEDIUM_ENEMY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 4,
        height: 4,
        materialName: "Pig",
        spine: s_pig_animation,
        animation: {
            scale: 0.4,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "PIG_BASIC_SMALL_ALLY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 2,
        height: 2,
        materialName: "SmallPig",
        spine: s_pig_animation,
        animation: {
            scale: 0.2,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "PIG_BASIC_SMALL_ENEMY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 2,
        height: 2,
        materialName: "SmallPig",
        spine: s_pig_animation,
        animation: {
            scale: 0.2,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "PIG_BASIC_BIG_ALLY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 6,
        height: 6,
        materialName: "BigPig",
        spine: s_pig_animation,
        animation: {
            scale: 0.6,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "PIG_BASIC_BIG_ENEMY": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 6,
        height: 6,
        materialName: "BigPig",
        spine: s_pig_animation,
        animation: {
            scale: 0.6,
            animation: PigSettings.idleAnimations[0].name,
            loop: true
        },
        sound: SoundManager.PigCollection.PIG
    },
    "TERRAIN_TEXTURED_HILLS_1X1": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 1,
        height: 1,
        materialName: "Static"
    },
    "TERRAIN_TEXTURED_HILLS_5X5": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 5,
        height: 5,
        materialName: "Static"
    },
    "TERRAIN_TEXTURED_HILLS_10X10": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 10,
        height: 10,
        materialName: "Static"
    },
    "TERRAIN_TEXTURED_HILLS_5X2": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 5,
        height: 2,
        materialName: "Static"
    },
    "TERRAIN_TEXTURED_HILLS_10X2": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 10,
        height: 2,
        materialName: "Static"
    },
    "TERRAIN_TEXTURED_HILLS_32X2": {
        type: PhysicsObjectType.box,
        image: s_static_ground,
        stretchImage: true,
        width: 32,
        height: 2,
        materialName: "Static"
    },
    "WOOD_TRIANGLE_4X4": {
        type: PhysicsObjectType.rightTriangle,
        image: WOOD_TRIANGLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "NEW_24_WOOD_TRIANGLE": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: WOOD_TRIANGLE_4X4_D1_2,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_TRIANGLE_4X4_HOLLOW": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: WOOD_TRIANGLE_4X4_HOLLOW_D1_2,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_CIRCLE_2X2": {
        type: PhysicsObjectType.circle,
        image: WOOD_CIRCLE_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_CIRCLE_4X4": {
        type: PhysicsObjectType.circle,
        image: WOOD_CIRCLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_1X1": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_1X1_D1,
        width: 1,
        height: 1,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_2X1": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_2X1_D1,
        width: 2,
        height: 1,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_2X2": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_4X1": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_4X1_D1,
        width: 4,
        height: 1,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_8X1": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_8X1_D1,
        width: 8,
        height: 1,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_10X1": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_10X1_D1,
        width: 10,
        height: 1,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_4X2": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_4X2_D1,
        width: 4,
        height: 2,
        materialName: "Wood",
        damageStates: 2
    },
    "NEW24_WOOD_2X8": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_8X2_D1,
        width: 8,
        height: 2,
        materialName: "Wood",
        damageStates: 2
    },
    "NEW_24_WOOD_2X10": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_10X2_D1,
        width: 10,
        height: 2,
        materialName: "Wood",
        damageStates: 2
    },
    "NEW_24_WOOD_4X4": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "WOOD_BLOCK_4X4_HOLLOW": {
        type: PhysicsObjectType.box,
        image: WOOD_BLOCK_4X4_HOLLOW_D1,
        width: 4,
        height: 4,
        materialName: "Wood",
        damageStates: 2
    },
    "ICE_TRIANGLE_4X4": {
        type: PhysicsObjectType.rightTriangle,
        image: ICE_TRIANGLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "NEW_24_LIGHT_TRIANGLE": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: ICE_TRIANGLE_4X4_D1_2,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_TRIANGLE_4X4_HOLLOW": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: ICE_TRIANGLE_4X4_HOLLOW_D1_2,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_CIRCLE_2X2": {
        type: PhysicsObjectType.circle,
        image: ICE_CIRCLE_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_CIRCLE_4X4": {
        type: PhysicsObjectType.circle,
        image: ICE_CIRCLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_1X1": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_1X1_D1,
        width: 1,
        height: 1,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_2X1": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_2X1_D1,
        width: 2,
        height: 1,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_2X2": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_4X1": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_4X1_D1,
        width: 4,
        height: 1,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_8X1": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_8X1_D1,
        width: 8,
        height: 1,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_10X1": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_10X1_D1,
        width: 10,
        height: 1,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_4X2": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_4X2_D1,
        width: 4,
        height: 2,
        materialName: "Ice",
        damageStates: 2
    },
    "NEW_24_LIGHT_2X8": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_8X2_D1,
        width: 8,
        height: 2,
        materialName: "Ice",
        damageStates: 2
    },
    "NEW_24_LIGHT_2X10": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_10X2_D1,
        width: 10,
        height: 2,
        materialName: "Ice",
        damageStates: 2
    },
    "NEW_24_LIGHT_4X4": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "ICE_BLOCK_4X4_HOLLOW": {
        type: PhysicsObjectType.box,
        image: ICE_BLOCK_4X4_HOLLOW_D1,
        width: 4,
        height: 4,
        materialName: "Ice",
        damageStates: 2
    },
    "STONE_TRIANGLE_4X4": {
        type: PhysicsObjectType.rightTriangle,
        image: STONE_TRIANGLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "NEW_24_STONE_TRIANGLE": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: STONE_TRIANGLE_4X4_D1_2,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_TRIANGLE_4X4_HOLLOW": {
        type: PhysicsObjectType.isoscelesTriangle,
        image: STONE_TRIANGLE_4X4_HOLLOW_D1_2,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_CIRCLE_2X2": {
        type: PhysicsObjectType.circle,
        image: STONE_CIRCLE_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_CIRCLE_4X4": {
        type: PhysicsObjectType.circle,
        image: STONE_CIRCLE_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_1X1": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_1X1_D1,
        width: 1,
        height: 1,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_2X1": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_2X1_D1,
        width: 2,
        height: 1,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_2X2": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_2X2_D1,
        width: 2,
        height: 2,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_4X1": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_4X1_D1,
        width: 4,
        height: 1,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_8X1": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_8X1_D1,
        width: 8,
        height: 1,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_10X1": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_10X1_D1,
        width: 10,
        height: 1,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_4X2": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_4X2_D1,
        width: 4,
        height: 2,
        materialName: "Stone",
        damageStates: 2
    },
    "NEW_24_STONE_2X8": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_8X2_D1,
        width: 8,
        height: 2,
        materialName: "Stone",
        damageStates: 2
    },
    "NEW_24_STONE_2X10": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_10X2_D1,
        width: 10,
        height: 2,
        materialName: "Stone",
        damageStates: 2
    },
    "NEW_24_STONE_4X4": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_4X4_D1,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "STONE_BLOCK_4X4_HOLLOW": {
        type: PhysicsObjectType.box,
        image: STONE_BLOCK_4X4_HOLLOW_D1,
        width: 4,
        height: 4,
        materialName: "Stone",
        damageStates: 2
    },
    "BigBird": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 3,
        height: 3,
        materialName: "BigBird",
        spine: s_birdTerence_animation,
        animation: {
            scale: 0.5,
            idle: "terence_idle",
            animation: "terence_fly",
            loop: false
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_red"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_red
        },
        sounds: SoundManager.BirdCollection.BIG,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.BigBirdDamageFactors,
        cardImage: s_card_big,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "Matilda": {
        type: PhysicsObjectType.circle,
        image: null,
        width: 3,
        height: 3,
        materialName: "WhiteBird",
        spine: s_birdMatilda_animation,
        animation: {
            scale: 0.5,
            idle: "matilda_idle",
            animation: "matilda_fly",
            loop: false
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_matilda"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        },
        featherParticle: {
            images: [s_feather],
            particle: p_feather_red
        },
        sounds: SoundManager.BirdCollection.MATILDA,
        soundOptions: {
            idleTimer: 8000
        },
        damageFactors: DamageFactors.WhiteBirdDamageFactors,
        cardImage: s_card_mathilda,
        cardScale: {
            xCardScale: 2,
            yCardScale: 2
        }
    },
    "MatildaEgg": {
        type: PhysicsObjectType.circle,
        image: s_s_matilda_egg,
        scale: 1,
        width: 1.5,
        height: 1.5,
        materialName: "MatildaEgg",
        deathExplosion: explosionTypeEgg
    }
};
(function () {
    var i = 1;
    for (var a in PhysicsObjectDefinition) {
        PhysicsObjectDefinition[a].generatedUID = i++;
    }
})();
export var BlockMaterialMap = {
    "Wood": ["WOOD_TRIANGLE_4X4", "NEW_24_WOOD_TRIANGLE", "WOOD_TRIANGLE_4X4_HOLLOW", "WOOD_CIRCLE_2X2", "WOOD_CIRCLE_4X4", "WOOD_BLOCK_1X1", "WOOD_BLOCK_2X1", "WOOD_BLOCK_2X2", "WOOD_BLOCK_4X1", "WOOD_BLOCK_8X1", "WOOD_BLOCK_10X1", "WOOD_BLOCK_4X2", "NEW24_WOOD_2X8", "NEW_24_WOOD_2X10", "NEW_24_WOOD_4X4", "WOOD_BLOCK_4X4_HOLLOW"],
    "Ice": ["ICE_TRIANGLE_4X4", "NEW_24_LIGHT_TRIANGLE", "ICE_TRIANGLE_4X4_HOLLOW", "ICE_CIRCLE_2X2", "ICE_CIRCLE_4X4", "ICE_BLOCK_1X1", "ICE_BLOCK_2X1", "ICE_BLOCK_2X2", "ICE_BLOCK_4X1", "ICE_BLOCK_8X1", "ICE_BLOCK_10X1", "ICE_BLOCK_4X2", "NEW_24_LIGHT_2X8", "NEW_24_LIGHT_2X10", "NEW_24_LIGHT_4X4", "ICE_BLOCK_4X4_HOLLOW"],
    "Stone": ["STONE_TRIANGLE_4X4", "NEW_24_STONE_TRIANGLE", "STONE_TRIANGLE_4X4_HOLLOW", "STONE_CIRCLE_2X2", "STONE_CIRCLE_4X4", "STONE_BLOCK_1X1", "STONE_BLOCK_2X1", "STONE_BLOCK_2X2", "STONE_BLOCK_4X1", "STONE_BLOCK_8X1", "STONE_BLOCK_10X1", "STONE_BLOCK_4X2", "NEW_24_STONE_2X8", "NEW_24_STONE_2X10", "NEW_24_STONE_4X4", "STONE_BLOCK_4X4_HOLLOW"]
};
